module.exports = __webpack_public_path__ + "media/pages/teens-515db72a.jpg";